import { Component, EventEmitter, Input, Output, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MesCusto } from '../../shared/model/relatorio-custo.models';
import { ChartCustosVerticalComponent } from '../charts/chart-custos-vertical/chart-custos-vertical.component';
import { ChartCustosHorizontalComponent } from '../charts/chart-custos-horizontal/chart-custos-horizontal.component';
import { BalaoAvisoComponent } from '../../shared/components/balao-aviso/balao-aviso.component';

@Component({
  selector: 'app-visao-anual',
  standalone: true,
  imports: [CommonModule, ChartCustosVerticalComponent, ChartCustosHorizontalComponent, BalaoAvisoComponent],
  templateUrl: './visao-anual.component.html',
  styleUrls: ['./visao-anual.component.css'],
})
export class VisaoAnualComponent {
  private readonly anoSig = signal(new Date().getFullYear());
  readonly anoValue = this.anoSig.asReadonly();
  @Input({ required: true })
  set ano(value: number) { this.anoSig.set(value); }

  private readonly mesesSig = signal<MesCusto[]>([]);
  readonly mesesValue = this.mesesSig.asReadonly();
  @Input({ required: true })
  set meses(value: MesCusto[] | null | undefined) { this.mesesSig.set(value ?? []); }

  private readonly totalAnualSig = signal(0);
  readonly totalAnualValue = this.totalAnualSig.asReadonly();
  @Input({ required: true })
  set totalAnual(value: number) { this.totalAnualSig.set(value ?? 0); }

  private readonly loadingSig = signal(false);
  readonly loadingValue = this.loadingSig.asReadonly();
  @Input()
  set loading(value: boolean) { this.loadingSig.set(!!value); }

  private readonly metaToggleSig = signal(false);
  readonly metaToggleValue = this.metaToggleSig.asReadonly();
  @Input()
  set metaToggle(value: boolean) { this.metaToggleSig.set(!!value); }

  @Output() toggleMeta = new EventEmitter<boolean>();

  private readonly maxAlpha = 0.59;
  private readonly minAlpha = 0.12;

  setoresLegenda = computed(() => {
    const acc = new Map<string, number>();

    for (const mes of this.mesesValue()) {
      for (const s of mes?.porSetor ?? []) {
        const nome = s?.setorNome ?? 'Sem setor';
        acc.set(nome, (acc.get(nome) ?? 0) + (s?.total ?? 0));
      }
    }

    return [...acc.entries()]
      .sort((a, b) => (b[1] ?? 0) - (a[1] ?? 0))
      .map(([nome]) => nome);
  });
  semDados = computed(() => {
    if (this.loadingValue()) {
      return false;
    }

    const meses = this.mesesValue();
    if (!meses.length) {
      return true;
    }

    return meses.every((mes) => {
      if ((mes?.total ?? 0) > 0) {
        return false;
      }

      return !(mes?.porSetor ?? []).some((setor) => (setor?.total ?? 0) > 0);
    });
  });

  getSetorColorByRank(index: number, total: number): string {
    const t = total <= 1 ? 0 : index / (total - 1);
    const curve = Math.pow(t, 1.8);

    const a = this.maxAlpha + (this.minAlpha - this.maxAlpha) * curve;
    return `rgba(153, 61, 245, ${a.toFixed(2)})`;
  }

  formatUSD(value: number) {
    return (value ?? 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }
}
